import React, { useState, useEffect } from "react";
import { Link, useNavigate,useLocation  } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Endpoints } from "../../Global/Endpoints";
import logo from "../../assets/images/logo-win-white.svg";
import himarklogo from "./../../assets/images/highmark/ffb-logo.jpg"
import loginImage01 from "../../assets/images/login/login-page-image-01.jpg";
import loginImage02 from "../../assets/images/login/login-page-image-02.jpg";
import loginImage03 from "../../assets/images/login/login-page-image-03.jpg";
import ErrorModal from "./ErrorModal";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useDispatch, useSelector } from "react-redux";
import { updateEmail } from '../../Redux/emailReducer';
import { updateUserData } from '../../Redux/userReducer';
import { setSSOData } from "../../Redux/ssoReducer";
import LanguageSelector from "../../Common/LanguageSelector";
import { useTranslation } from 'react-i18next';
import { setSSODetails } from "../../Redux/ssoQueryParamsDetails"; // Import your actions

import { useChat } from "../Layout/ChatContext";
// ✅ Top of file — before Login component
const queryParams = new URLSearchParams(window.location.search);
//const redirection = queryParams.get("Redirection");
const ssoId = queryParams.get("SSO_ID");
const ssoParams = queryParams.get("SSO_PARAMS");
const ssoCallback = ssoId && ssoParams;
const ssoInProgress = sessionStorage.getItem("ssoRedirectInProgress") === "true";
sessionStorage.setItem("ssofullUrl", window.location.href);

// ✅ For any SSO callback, assume it's Highmark and set the brand if not already set
if (ssoCallback && !sessionStorage.getItem("ssoBrand")) {
  sessionStorage.setItem("ssoBrand", "Highmark");
  sessionStorage.setItem("ssoRedirectInProgress", "true");
}

// ✅ Clear stale SSO brand flags if it's NOT SSO login
if (!ssoCallback && !ssoInProgress) {
  sessionStorage.removeItem("ssoRedirectInProgress");
  sessionStorage.removeItem("ssoBrand");
}


const cookies = new Cookies();
const SESSION_KEY = "AccessToken";
const EXPIRATION_KEY = "sessionExpiration";

const Login = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [inactiveMemberData,setMemberinactiveflageData] = useState(null);
  const [modalMessageHeader,setModalMessageHeader] = useState("");
  const [loading, setLoading] = useState(false);
  // Added payment modal state
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentModalMessage, setPaymentModalMessage] = useState("");
  const [isContinue, setContinue] = useState(false);
  

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const location = useLocation();
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]{2,}\.([A-Za-z0-9-]{2,})(?:\.([A-Za-z0-9-]{2,}))?$/;
  const [isSSOProcessing, setIsSSOProcessing] = useState(() => {
    const ssoBrand = sessionStorage.getItem("ssoBrand");
    const queryParams = new URLSearchParams(window.location.search);
    const ssoId = queryParams.get("SSO_ID");
    const ssoParams = queryParams.get("SSO_PARAMS");
    const ssoInProgress = sessionStorage.getItem("ssoRedirectInProgress") === "true";
    // Start processing immediately if it's Highmark SSO or any SSO callback
    return (ssoId && ssoParams) || 
           (ssoInProgress && ssoBrand === "Highmark");
  });
    // Initialize Highmark SSO state immediately based on available data
  const [isHighmarkSSO, setIsHighmarkSSO] = useState(() => {
    const ssoBrand = sessionStorage.getItem("ssoBrand");
    const queryParams = new URLSearchParams(window.location.search);
    const ssoId = queryParams.get("SSO_ID");
    const ssoParams = queryParams.get("SSO_PARAMS");
    const ssoInProgress = sessionStorage.getItem("ssoRedirectInProgress") === "true";
    
    return (ssoId && ssoParams && ssoBrand === "Highmark") || 
           (ssoInProgress && ssoBrand === "Highmark");  });

//sso integration into patient portal

const { hideChat } = useChat();
useEffect(() =>{
  hideChat();
}
)

useEffect(() => {
  const ssoInProgressLocal = sessionStorage.getItem("ssoRedirectInProgress") === "true";
  if (ssoInProgressLocal || isHighmarkSSO) return;

    if (location.state?.from !== "Logout") {
      dispatch({ type: "CLEAR_REDUX_STATE" });
    }
  }, [dispatch, location, isHighmarkSSO]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const isSSOCallback = queryParams.has("SSO_ID") && queryParams.has("SSO_PARAMS");
    const ssoInProgressLocal = sessionStorage.getItem("ssoRedirectInProgress") === "true";
    
    if (!isSSOCallback && !ssoInProgressLocal && !isHighmarkSSO) {
      sessionStorage.removeItem("ssoRedirectInProgress");
      sessionStorage.removeItem("ssoBrand");
      sessionStorage.removeItem("highmarkSession");
    }
  }, [location, isHighmarkSSO]);  // Clear the flag once the user reaches login properly
  useEffect(() => {
    const ssoInProgressLocal = sessionStorage.getItem("ssoRedirectInProgress") === "true";
    if (!ssoInProgressLocal && !isHighmarkSSO) {
      sessionStorage.removeItem("ssoRedirectInProgress");
      sessionStorage.removeItem("ssoBrand"); // also clear brand
    }
  }, [location.search, isHighmarkSSO]);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const ssoId = queryParams.get("SSO_ID");
    const ssoParams = queryParams.get("SSO_PARAMS");
    const ssoInProgressLocal = sessionStorage.getItem("ssoRedirectInProgress") === "true";
    
    if (ssoId && ssoParams) {
      setIsSSOProcessing(true); // Show loading while validating SSO
      sessionStorage.setItem("ssoId", ssoId);
      sessionStorage.setItem("ssoParams", ssoParams);
      dispatch(setSSODetails(ssoId, ssoParams));  
      validateSSOUser(ssoId, ssoParams);
    }
    else 
    {
      // Only set to false if not in SSO progress mode and not Highmark SSO
      if (!ssoInProgressLocal && !isHighmarkSSO) {
        setIsSSOProcessing(false);
      }
    }
  }, [location, isHighmarkSSO]);// Early detection of Highmark SSO
  useEffect(() => {
    const ssoBrand = sessionStorage.getItem("ssoBrand");
    const queryParams = new URLSearchParams(location.search);
    const ssoId = queryParams.get("SSO_ID");
    const ssoParams = queryParams.get("SSO_PARAMS");
    const ssoInProgress = sessionStorage.getItem("ssoRedirectInProgress") === "true";
    
    // Check multiple sources for Highmark SSO detection
    if ((ssoId && ssoParams && ssoBrand === "Highmark") || 
        (ssoInProgress && ssoBrand === "Highmark") ||
        (existingSSOData?.Portal === "Highmark")) {
      setIsHighmarkSSO(true);
      setIsSSOProcessing(true);
    }
  }, []); // Run only once on mount

  // Get SSO data from Redux
  const reduxSSO = useSelector((state) => state.ssoQueryParamsDetails);
  const existingSSOData = useSelector((state) => state.sso.ssoUserData);
  console.log("Redux SSO values:", reduxSSO);

  // Consolidated loading condition - must be defined early
  const ssoInProgressLocal = sessionStorage.getItem("ssoRedirectInProgress") === "true";
  const showLoading = ssoInProgressLocal || isSSOProcessing || isHighmarkSSO;

  // Function to validate SSO user
  const validateSSOUser = async (ssoId, ssoParams) => {
    try {
      const params = {
        SSO_ID: ssoId,
        SSO_PARAMS: ssoParams,
      };

      const response = await axios.post(
        Endpoints.ValidateSSO,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );      if (response.data!=null) {
        // Check if this is a Highmark SSO
        if (response.data?.Portal === "Highmark") {
          setIsHighmarkSSO(true);
        }
        console.log("SSO validation response:", response.data);
        const token = response.data?.Token;
        if (token) {
          debugger
          console.log("SSO validation successful:", response.data);
          console.log("Calling handlelogin from validteSSO")
          handleLogin(null,true,response.data);
        }
        else{
          debugger
          if (response.data?.domainInfo === "MyHighmarkIEL") {
          // If first/last name are present, do SSO redirect
          if (!response.data?.FirstName || !response.data?.LastName) {
            window.location.href = "https://auth.highmark.com/home?bmctx=631B249BF72C0BFF3661DEAAA9886192379CFE673ED1137D17410C3D2C757F8F6BCD8A3C1908273832F824E9E115FDCA6390AECEE064155A352EF8CEB28AA4DE&password=secure_string&respCookies=Secure;httponly;SameSite%3DNone;&contextType=external&miscCookies=Secure;httponly;SameSite%3DNone;&ssoCookie=Secure;httponly;SameSite%3DNone;&username=string&challenge_url=https:%2F%2Fauth.highmark.com%2F&request_id=-5676144048537218152&authn_try_count=0&locale=en_US&resource_url=https%253A%252F%252Fauth.highmark.com%252Fhmkoauth%252FuserConsent.jsp%253Fstate%253DZXBBOEhrOHRZdk0xT1dFNHZyT2VVZz09fmNjdGlucEFqSy91MEhISG9WdzNQOG1COHIyWVc0ckxsVEkwbmszT0NzN3E3MTFSemp1SW5pWFlUT21TY3hEeEVSdFFCWHQySURMaGU5MmxvTk05OHQvUUhCZW9kMWFqRzY4MFJuY3pCV2FZSk5QTzhTcTZGK05ubWtpOWxYWGRzVThPQlBuTWFiV1kweCtGVzJna3NZQkVMa2hRN25kY3hGWGRNYWRBZUpyWWFsSjFZMy96aHpvVmVrdEZSYjMzNm5PM2x4V3p5Zkg5azdGamtLUzYwaTlSeUNEZDBsV0hhUW9nTUVFLyt4MjIyWlBXdG9NelNQZkdJSWI3Y0VRM1MzcGEwdTI0U3J0Z1hoYUxYOGFlQnNRcStrVDBBazFYZkx3a0V6bW53Y0cyWWd1US8zZEVOcXBubXZGSERSRlJPbFUyZ0R2QjBQdFZtaU9RUkNBVU5KVDBFbmpLVnNRNllOYXBsNHBVY0hFWnpsQ0d4VDlzU3lSalpLd25UMjl5TW1pWmhCdDFCcUZ1VEg5VWRQTlgwc2lJdnpiZnovb3kvUG15dXoxMUN1MkE9%2526scopes%253Dopenid%252Boffline_access%252Bprofile%252Bresource.READ%252Bmember.external.read-only%252Bmember.external.update%2526client_id%253D4346795-5572-b394-577336f656c61466858347a656c773d3d";
          return;
          }
        } else if (response.data?.domainInfo === "allmyhealth") {
          if (!response.data?.FirstName || !response.data?.LastName) {
            window.location.href = "https://auth.allmyhealth.com/home?bmctx=631B249BF72C0BFF3661DEAAA98861924F2730C2597459EC902D19660439EBE89CF838BB360E94490B14E14E5931CDF0&password=secure_string&respCookies=Secure;httponly;SameSite%3DNone;&contextType=external&miscCookies=Secure;httponly;SameSite%3DNone;&ssoCookie=Secure;httponly;SameSite%3DNone;&username=string&challenge_url=https:%2F%2Fauth.allmyhealth.com%2F&request_id=-1611346045285673224&authn_try_count=0&locale=en_US&resource_url=https%253A%252F%252Fauth.allmyhealth.com%252Fhmkoauth%252FuserConsent.jsp%253Fstate%253DS3BnKzArUi9lNnk2T0UvaXU3L1NpZz09fklpZEY0YU9ySUdUc3F2elc5K3dEMmpqeVo5WVd3N1k0TXZmaFZvMW5Kd0lHRHoxbVI4WG9HdjVOQjVXMzg0NUw2ZFB1QXlGUWZ1emkxV29jS2pibTRZeHhpdzc0aFkrdFRDN1dCbUc5azdIVWozYlpDWjVkQWlXTDQ1dHlsYldjWGtTbDB6cWMvSkdKcExNYUhrZTJyZGs4US9rYWNFNnBUQy9KSnFSaG9KM1pWc2plY0RaTGl2MjF6WEp3Zk1SMkwwWEpGdFdTWTlkZlhUbDRVYW85TlpBQ3FRRkRVeTdOUm5QS1dKM0pJcnVOS2tSOXd6R2gyekoxeWJoamRKdWJ4eWtKd1hta25EK1kvaXNTaFFtTDlIaVI3cGJWQ0hMaHAxNUtacmE1UnhmUTFuQmlhMFVoelo4bU1QOWpvanpRR2ovNVJEc1U1aU9Kc3FLemhLUDZCMG56R0NHaUdNOVBsSVJlcXp3dnBtV0cxVjI5b3M5UXJwajN2a2ttcmNZOFd1UzFuM25UMThuRFhnNTVQTjdnS09QZWViUTVIbzRtUmFiQlJDdERGUDg9%2526scopes%253Dopenid%252Boffline_access%252Bprofile%252Bresource.READ%252Bmember.external.read-only%252Bmember.external.update%2526client_id%253D7a2b6d4-d556-8715-67a4b47694e313059724464496a773d3d";
            return;
          }
          }
          debugger
          //  const expirationTime = Date.now() + 20 * 1000; // 10 seconds for testing
         setTimeout(() => {
          dispatch(setSSOData(response.data));

  const expirationTime = Date.now() + 15 * 60 * 1000; // 15 minutes
  localStorage.setItem(EXPIRATION_KEY, expirationTime);
  localStorage.removeItem("sessionExpired");
  cookies.set(SESSION_KEY, token, { path: "/" });
  dispatch({
    type: 'LOGIN_SUCCESS',
    payload: token,
  });
   navigate("/registration-form-one")
}, 2000);
        }
      } else {
        setModalMessage(response.data?.Message || "SSO validation failed.");
        setShowModal(true);
        // Only reset processing state if it's not Highmark SSO
        if (!isHighmarkSSO) {
          setIsSSOProcessing(false);
        }
      }    } catch (error) {
      setModalMessage("Error validating SSO login.");
      setShowModal(true);
      // Only reset processing state if it's not Highmark SSO
      if (!isHighmarkSSO) {
        setIsSSOProcessing(false);
      }
    }
  };

  // Force logout/reset on login page mount
  useEffect(() => {
    dispatch({ type: "LOGOUT" });
  }, [dispatch]);

    // Handle login
    const { subRedirection, updatedLink } = location.state || {};
    const handleLogin = async (e, isValidSSO = false, ssoData = null) => {
      console.log("location.state : ", location.state, " subRediredction : ", subRedirection, " updatedLink : ", updatedLink)
      console.log("HandleLogin called. isValidSSO:", isValidSSO, "ssoData:", ssoData);
      if (!isValidSSO) {
        e.preventDefault();
        if (!validateForm()) {
          return;
        }
      }
      const params = {
        EmailID: isValidSSO ?ssoData.Emailid: email,
        Password: isValidSSO ?"":password,
        FingerPrint: "",
        EncryptPassword: "",
        DeviceType: "",
        Version: "",
        AppLanguage: "",
        DeviceType:"PatientPortal",
        isSSO : isValidSSO,

      };
      setLoading(true); // <-- Set loading to true before fetch
      try {
        const response = await axios.post(
          Endpoints.LogIn,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            }
          }
        );
        if (response.data.UKDTC === "Y"){
          setShowPaymentModal(true);
          setPaymentModalMessage(t("The payment is still pending. Please complete the payment process to access the app."));
          dispatch(updateUserData(response.data));
          return;
        }
        if (response.data.Result === 2) {

          fetch('/deploy-complete.txt', { cache: 'no-store' })
          .then(res => res.text())
          .then(content => {
            const currentDeployVersion = content.trim();
            sessionStorage.setItem('loginDeployVersion', currentDeployVersion);
          });
         if(response.data?.MemberInActiveFlag === "Yes")
{
  setMemberinactiveflageData(response.data);
  setContinue(true);
  setShowModal(true);
  setModalMessageHeader(t("It looks like something didn't go as expected"));
  setModalMessage(t("If you have a new employer/health plan that offers WIN, tap \"Continue\" to update your information. If you need help, our team is happy to assist at 855-255-7197."));
  return; // stop further navigation or code execution!
}

    if(isValidSSO)
    {
      sessionStorage.setItem("ssoLoginCompleted", "true");
    }          let token = isValidSSO?  ssoData?.Token : await getTokenId(); 
          // const expirationTime = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
          // const expirationTime = Date.now() + 20 * 1000; // 10 seconds for testing
          const expirationTime = Date.now() + 15 * 60 * 1000; // 15 minutes
          const employer = response.data.Employer;
          localStorage.setItem(SESSION_KEY, token);
          localStorage.setItem(EXPIRATION_KEY, expirationTime);
          localStorage.removeItem("sessionExpired");
          cookies.set(SESSION_KEY, token, { path: "/" });
          dispatch({
            type: 'LOGIN_SUCCESS',
            payload: token,
        })
        dispatch(updateEmail(isValidSSO ? ssoData.Emailid : email));

        const userData = {
          ...response.data
        };
        // Dispatch the user data to Redux
        dispatch(updateUserData(userData));
        dispatch(setSSOData(ssoData));
       // dispatch(setSSOData({ Portal: "Highmark"}));
        window.dispatchEvent(new Event('storage'));
        if (userData.IsInactive === "Yes") {
          navigate("/patient-checkin-after-six-months");
        } else if (userData.IsEnable4thTrimister === "Y") {
          navigate("/fourth-trimester-landing-page");
        } else {

           const queryParams = new URLSearchParams(window.location.search);
          const redirection = queryParams.get("Redirection");
          console.log("handlelogin redirection : ", redirection)


         if (redirection) {
          console.log("redirection is present")
          debugger
            let selectedType = redirection.split('-')[0];
            let SlotType = redirection;

            // Call saveQRMemberDetails before navigating
            await saveQRMemberDetails(userData, token);

            navigate('/calendar-view', { state: { selectedType, SlotType, fromSSO: true } });
            return;
          }
          localStorage.setItem('BenefitTabVisibility', response.data.BenefitTabVisibility);
          localStorage.setItem('InsuranceCardVisibility', response.data.InsuranceCardVisibility);
          localStorage.setItem('employer', employer);

          console.log("handleLogin: Navigating to home with redirection : ", redirection)

          if (subRedirection && updatedLink) {
            navigate("/home", { state: { subRedirection : subRedirection, updatedLink, updatedLink}})
          } else {
            navigate("/home");
          }
         debugger
        }      
        } 
        else if (response.data.UKDTC !== "Y" && response.data.Result !== 2 && response.data && response.data.Message) {
          // Show server validation error in modal
          // Only reset processing state if it's not Highmark SSO
          if (!isHighmarkSSO) {
            setIsSSOProcessing(false);
          }
          setModalMessage(response.data.Message);
          setShowModal(true);
        } else {
          // Only reset processing state if it's not Highmark SSO
          if (!isHighmarkSSO) {
            setIsSSOProcessing(false);
          }
          setModalMessage(t("loginfailed"));
          setShowModal(true);
        }      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.Message
        ) {
          // Only reset processing state if it's not Highmark SSO
          if (!isHighmarkSSO) {
            setIsSSOProcessing(false);
          }
          setModalMessage(error.response.data.Message);
        } else {
          // Only reset processing state if it's not Highmark SSO
          if (!isHighmarkSSO) {
            setIsSSOProcessing(false);
          }
          setModalMessage(t("erroraccured"));
        }
        setShowModal(true);
      }  finally {
      setLoading(false); // <-- Ensure loading is set to false after fetch
    }
    };
    const handleModelCancel = () => {
      setShowModal(false);
      setContinue(false);
    }
const handleModalOkay = () => {
  setShowModal(false);
  setContinue(false);
 const token= getTokenId(); // Fetch token again if needed
 localStorage.setItem('AccessToken', token);
  dispatch({ type: "SET_FROM_LOGIN", payload: true });
  navigate("/benefit-options", { state: { InActiveMemberData: inactiveMemberData} });
};

  // Function to validate email
  function validateEmailRegex(email) {
    const match = email.match(emailRegex);

    if (match) {
      // Get the captured domain parts
      const domainParts = match.slice(1);

      // Ensure the domain parts are unique
      const uniqueDomains = new Set(domainParts);

      // Return true if the size of unique domains matches the number of domain parts
      return uniqueDomains.size === domainParts.length;
    } else {
      return false; // Does not match regex pattern
    }
  }

    // Form validation
    const validateForm = () => {
      let isValid = true;

      // Email validation
      if (!email) {
        setEmailError(t("emailvalid"));
        isValid = false;
      } else if (!validateEmailRegex(email)) {
        setEmailError(t("emailpattern"));
        isValid = false;
      } else {
        setEmailError("");
      }

      // Password validation
      if (!password) {
        setPasswordError(t("passwordvalid"));
        isValid = false;
      } else {
        setPasswordError("");
      }

      return isValid;
    };

    // Handle changes for email and password fields
    const handleChangeEmail = (e) => {
      setEmail(e.target.value);
      if (!emailRegex.test(e.target.value)) {
        setEmailError(t("emailpattern"));
      } else {
        setEmailError("");
      }
    };

    const handleChangePassword = (e) => {
      setPassword(e.target.value);
      if (!e.target.value) {
        setPasswordError(t("passwordvalid"));
      } else {
        setPasswordError("");
      }
    };



    // Fetch the token and store it in cookies and local storage
    const getTokenId = async () => {
      const devicetype="PatientPortal"
      try {
        const response = await axios.post(
          Endpoints.GET_Token,
          `Password=${encodeURIComponent(password)}&UserName=${encodeURIComponent(email)}&DeviceType=${encodeURIComponent(devicetype)}`,
          
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            }
          }
          
        );
        if (response.data?.Token?.TokenId) {
          const token = response.data.Token.TokenId;
          
          // Store token in cookies and local storage
          cookies.set('AccessToken', token, { path: '/' });
          localStorage.setItem('AccessToken', token);

          return token;
        }
      } catch (error) {
        toast.error(t("toastmessage"));
        return null;
      }
    };

    // Initialize carousel on component mount
    useEffect(() => {
      const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
        if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }    }, []);



const isHighmarkPortal = process.env.REACT_APP_IS_HIGHMARK === "true";
const hasSSOParams = Boolean(ssoId && ssoParams);
const isLogoutRedirect = location.state?.from === "Logout";

const isHighmarkLoginBlocked = isHighmarkPortal && !hasSSOParams && !isLogoutRedirect;

if (isHighmarkLoginBlocked) {
  return (
    <>
    <div className="container">
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <img src={himarklogo} alt="himarklogo" className="brand-logo" style={{height: "50px"}} />
        </nav>
      </header>
    </div>
      <div style={{height: "80vh"}} className="d-flex flex-column align-items-center justify-content-center">
        
        <h2 style={{color: "#0074c9"}}>Please login to this application through MyHighmark or AllMyHealth.</h2>
    </div>
    </>    
  );
}

console.log(inactiveMemberData)

if (loading && !showLoading) {
  return (
    <div className="loading-container">
      <div className="loading"></div>        
      <h2 className="loading-text">{t("loading")}</h2>
    </div>
  );
}

  return (
   <> 
   {showLoading ? (
    <div >
    <div></div>        
    <h2 >{t("loading")}</h2>
  </div>
  ): ( <div className="login-main">
      {/* <div> <LanguageSelector /></div> */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
            <img src={logo} alt="Logo" className="logo" />
            <input type="hidden" id="isLoginPage" value={"true"} ></input>
          </a>
        </nav>
      </header>

      <div className="login-block-main">
        <div className="login-image-wrapper">
          <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="login-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="login-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="login-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="login-form-main">
          <div className="login-form">
            <h2 className="page-heading text-center mt-0">{t('login')}</h2>
            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <label htmlFor="email" className="form-label win-form-label mandatory">{t('emailId')}</label>
                <input
                  type="text"
                  className="form-control win-form-control w-100"
                  id="email"
                  placeholder={t('enteryouremail')}
                  value={email}
                  onChange={handleChangeEmail}
                  maxLength={100}
                  autoComplete="off"
                />
                {emailError && <div className="form-field-error-message">{emailError}</div>}
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className="form-label win-form-label mandatory">{t('password')}</label>
                <input
                  type={passwordVisible ? "text" : "password"}
                  className="form-control win-form-control w-100"
                  placeholder={t('enteryourpassword')}
                  value={password}
                  onChange={handleChangePassword}
                  maxLength={50}
                  autoComplete="off"
                />
                {passwordError && <div className="form-field-error-message">{passwordError}</div>}
              </div>
              
              <div className="mb-3 switch-control-wrapper">
                <label className="switch">
                  <input
                    type="checkbox"
                    className="switch-input"
                    onChange={() => setPasswordVisible(!passwordVisible)}
                  />
                  <span className="slider round"></span>
                </label>
                <span className="switch-label">{t('showpassword')}</span>
              </div>

              <button type="submit" className="win-btn-primary mt-4">{t('loginbutton')}</button>
            </form>

            <div className="login-links-wrapper mt-5">
              <Link to="/forgotpassword" className="forgot-password">{t('forgotpassword')}</Link>
            </div>

            <div className="login-links-wrapper">
              <Link to="/registration-form-one" className="create-new-account">{t('createaccount')}</Link>
            </div>
          </div>
        </div>
      </div>
{inactiveMemberData?.MemberInActiveFlag === "Yes" && showModal ? (
  <ErrorModal
    show={showModal}
    title={modalMessageHeader}
    message={modalMessage}
    onContinue={isContinue}
    onOkay={handleModalOkay}
    onClose={handleModelCancel}
    //onClose={() => setShowModal(false)}
  />
) : (
  <ErrorModal
    show={showModal}
    message={modalMessage}
    onClose={() => setShowModal(false)}
  />
)}

      {/* Added Payment Modal */}
      <ErrorModal
        show={showPaymentModal}
        message={paymentModalMessage}
       
        onOkay={() => {
          setShowPaymentModal(false);
          dispatch({ type: 'PASSWORD', payload: password });
          dispatch({ type: "SET_FROM_LOGIN", payload: true });
          navigate('/payment', { state: { fromLogin: true, password } });
        }}
        onClose={() => setShowPaymentModal(false)}
        showConfirmButtons={true}
      />

    </div>)}
    </>
    )
};

export default Login;

const saveQRMemberDetails = async (userData, token) => {
  console.log('Saving QR Member Details with userInfo to SaveQRMemberDetails:', userData);
  debugger
  try {
    const params = {
      EmailID: userData?.EmailID || "",
      MemberID: userData?.MemberID || "",
      Contract: userData?.ContractIdentified || "",
      FirstName: userData?.FirstName || "",
      Lastname: userData?.LastName || "",
      DeviceType: "PatientPortal",
    };

    const response = await axios.post(
      Endpoints.SaveQRMemberDetails,
      `_Params=${encodeURIComponent(JSON.stringify(params))}`,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.data === "Sucess") {
      console.log('SaveQRMemberDetails response:', response.data);
    }
    else {
      console.error('Failed to save QR Member details:', response.data);
    }
  } catch (error) {
    console.error('Error fetching SaveQRMemberDetails:', error);
  }
};
